import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { saveAs } from "file-saver"
import * as Rx from "rxjs"
import { map, retry } from "rxjs/operators"
import type {
    OrderPaymentStatus,
    OrderPaymentType,
    OrderReportApiParameters,
    OrderSource,
    OrderStatus,
} from "../../components/screens/reports/orders/types"
import { request } from "../../utils/http"

export type GetOrdersReportServerResponse = {
    content: OrdersReportResponseItem[]
    total_count: number
    page_size: number
    offset: number
}

export type OrdersReportResponseItem = {
    id: string
    assignee_name?: string
    assignment_name?: string
    order_number: string
    tip: Maybe<number>
    card_names?: string[]
    external_types?: string[]
    customer_name?: string
    location_id: string
    location_name: string
    opened: string
    closed: Maybe<string>
    payment_status: OrderPaymentStatus
    payment_status_code: string
    payment_types: OrderPaymentType[]
    status: OrderStatus
    source: OrderSource
    tips_amount: Maybe<number>
    gratuity_amount: Maybe<number>
    terminal_name: string
    total: Maybe<number>
    deleted: boolean
}

export const getOrdersCsvReportApi = (
    headers: Record<string, any>,
    config: OrderReportApiParameters
): Rx.Observable<GetOrdersReportServerResponse> =>
    Rx.defer(() =>
        request({
            method: "GET",
            parameters: config,
            path: "/report/v2/orders/csv",
            headers: headers,
            withResponseHeaders: true,
        })
    ).pipe(
        map(({ responseBody, responseHeaders }) => {
            const filename = responseHeaders.get("content-disposition").split("filename=")[1]
            const filetype = responseHeaders.get("Content-Type")
            const blob = new Blob([responseBody], {
                type: filetype,
            })
            return saveAs(blob, filename)
        }),
        retry(3)
    )
